import React from "react";
import { Navigate, useSearchParams } from "react-router";
import { REPORT_PAGES_ROUTES } from "@sscs/report/constants";

const RedirectToNewDiffRoute = (): React.JSX.Element => {
  const [searchParams] = useSearchParams();

  return (
    <Navigate
      to={{
        pathname: `../${REPORT_PAGES_ROUTES.VERSION_DIFF}`,
        search: searchParams.toString(),
      }}
      replace
      relative="path"
    />
  );
};

export default RedirectToNewDiffRoute;
